'use strict';

var myDetailsModule = angular.module("app.myDetailsModule", []);


myDetailsModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider: ng.ui.IStateProvider, $locationProvider: angular.ILocationProvider) {

        console.log('app.myDetailsModule config...');

        $stateProvider
            .state("accoladeOptions",
            {
                url: "/accoladeOptions",
                templateUrl: "assets/templates/myProfile/accoladeOptions.html",
                controller: 'accoladeOptionsViewCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Accolade Mailing Options"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
            .state("researchSubscriptions",
            {
                url: "/researchSubscriptions",
                templateUrl: "assets/templates/myProfile/researchSubscriptions.html",
                controller: 'researchSubscriptionsViewCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Manage Research Subscriptions"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
            .state('profile', {
                url: '/profile',
                templateUrl: 'assets/templates/myProfile/profile.html',
                controller: "profileCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Profile"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
    }]);

myDetailsModule.controller('myDetailsBaseCtrl', Patersons.MyDetailsBaseCtrl);
myDetailsModule.controller('accoladeOptionsViewCtrl', Patersons.AccoladeOptionsViewCtrl);
myDetailsModule.controller('researchSubscriptionsViewCtrl', Patersons.ResearchSubscriptionsViewCtrl);
